import { inject, Injectable } from '@angular/core';
import {
  ServiceInventoryService,
  ServiceState
} from '@brightside-web/desktop/data-access/service-inventory';
import { toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map } from 'rxjs';
import { SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';


@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private _serviceInventory = inject(ServiceInventoryService);
  private _modalSvc = inject(SimpleGlobalModalService);

  readonly state = toSignal<ServiceState | null>(
    this._serviceInventory.getService('onboarding').pipe(
      map((it) => it?.state ?? null),
      distinctUntilChanged()
    ),
    { initialValue: null }
  );

  readonly error = toSignal(
    this._serviceInventory.getError().pipe(distinctUntilChanged()),
    { initialValue: undefined }
  );

  constructor() {
  }

  loadInventory() {
    return this._serviceInventory.loadInventory('onboarding');
  }

  somethingWentWrong(retry: () => unknown = () => this.loadInventory()) {
    const retryAction = () => {
      this._modalSvc.clearModal();
      retry();
    };
    this._modalSvc.createGenericErrorModal('onboarding', retryAction, 'TRY_AGAIN');
  }
}
